import type { ChartType, SecondaryDimensionValues } from '@revelio/core';

import type { PrimaryFilterId } from '../../../filters/types/filters';
import { ChartFallback } from '../../Chart/ChartFallback';
import type { ResolvedData } from '../../DataResolver/resolve-items';
import { useCompositionData } from '../composition/useCompositionData';
import type {
  DataProviderChildren,
  SingleDataSet,
  TimeseriesDataSet,
} from '../types';
import {
  convertWagePressureData,
  convertWagePressureTable,
} from './convert-wage-pressure';

type WagePressureDataSet = SingleDataSet | TimeseriesDataSet | undefined;

export const WagePressureDataProvider = ({
  primaryDimension,
  secondaryDimension,
  metric,
  chartType,
  composition,
  children,
}: {
  primaryDimension: PrimaryFilterId;
  secondaryDimension?: SecondaryDimensionValues;
  metric: 'wage_pressure' | 'wage_pressure_percentile';
  chartType: ChartType;
  composition?: ResolvedData;
  children: DataProviderChildren<WagePressureDataSet>;
}) => {
  const {
    compositionData,
    monthRefs,
    status: compositionStatus,
  } = useCompositionData(primaryDimension, {
    pause: composition !== undefined,
  });
  const status = composition?.status ?? compositionStatus;
  const isTimeseries =
    chartType === 'line' ||
    chartType === 'volume' ||
    secondaryDimension === 'timeseries';

  return (
    <ChartFallback status={status}>
      {children({
        data: composition
          ? composition.data &&
            convertWagePressureTable({
              table: composition.data,
              metric,
              isTimeseries,
            })
          : convertWagePressureData({
              data: compositionData?.entities ?? [],
              isTimeseries,
              metric,
              monthRefs,
            }),
        status,
      })}
    </ChartFallback>
  );
};
